import Status from "./Status";
import OrganizationalRole from "./OrganizationRole";
import Group from "./Group";
import { IOrganization } from "./interfaces/IOrganization";
import ProductLicense from "./ProductLicense";
import Product from "./Product";

export default class Organization implements IOrganization {
  // Object associations
  public roles: Array<OrganizationalRole> | undefined;
  public groups: Array<Group> | undefined;
  public status: Status = new Status();
  public productLicense: ProductLicense = new ProductLicense();
  public productLicenses: Array<ProductLicense> = [];

  // Properties
  public id: string = "";
  public name: string = "";
  public type: number = 100;
  public email: string = "";
  public description: string = "";
  public websiteUrl: string = "";
  public address1: string = "";
  public address2: string = "";
  public city: string = "";
  public stateOrProvince: string = "";
  public country: string = "";
  public postalCode: string = "";
  public phoneNumber: string = "";
  public createdAt: string = "";
  public updatedAt: string = "";
  public resellerId: string = "";
  public reseller: object = {};
  public imageUri: string = "";
  public allowCreatingPublicLibrary: boolean = false;
  public allowSiloLibrary: boolean = false;
  
  // Constructor
  constructor(name: string = "", email: string = "") {
    this.name = name;
    this.email = email;
  }
}
